<script setup>
import {computed, ref} from 'vue'
    import IconChevron from "../../icons/iconChevron.vue";

    const props = defineProps({
       item: {
          type: Object,
          required: true
       },
        preview: {
            type: Boolean,
            required: false,
            default: false
        }
    });

    const navigationExpanded = ref(false)

    const toggleNavigation = () => {
        navigationExpanded.value = !navigationExpanded.value
    }

    const linkTarget = computed(() => {
        if (props.preview) {
            return '_blank';
        } else {
            return '_self';
        }
    })

</script>
<template>
    <div
        class="w-full md:w-auto bg-b"
        @mouseenter="navigationExpanded = true"
        @mouseleave="navigationExpanded = false"
    >
        <div
            class="flex items-center justify-between pl-2 md:pl-0 group md:justify-start"
        >
            <slot></slot>
            <button
                v-if="item.subItems?.length > 0"
                @click="toggleNavigation"
                class="relative ml-2 flex h-6 w-3 items-center md:m-0.5 md:h-4"
            >
                <icon-chevron
                    class="absolute inset-0 h-6 w-6 transform transition md:h-4 md:w-4"
                    :class="navigationExpanded ? 'rotate-180 fill-current opacity-90' : 'fill-current'"
                />
            </button>
        </div>
        <div
            v-if="item.subItems?.length > 0"
            class="-mt-2 md:z-topbar md:absolute md:top-full left-0"
            :class="navigationExpanded ? 'block' : 'hidden'"
        >
            <ul
                class="border-wlPrimary mx-0 ml-0 rounded-lg shadow-md"
            >
                <li
                    v-for="(subItem, i) in item.subItems.filter(si => si.visible === true)"
                    class="px-1 py-2 md:p-4"
                >
                    <a
                        :target="linkTarget"
                        :href="subItem.href"
                        class="hover:underline hover:outline-none mf-link-immune whitespace-nowrap"
                    >
                        {{ subItem.name }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>
